import React from 'react';
import Hero from '../components/Hero';
import AboutSection from '../components/AboutSection';
import DiaDeCampoCallout from '../components/DiaDeCampoCallout';
import NewsSection from '../components/NewsSection';
import QuotationsSection from '../components/QuotationsSection';
// import InstagramSection from '../components/InstagramSection';
import WeatherSection from '../components/WeatherSection';
import ProjectsSection from '../components/ProjectsSection';
import ContactSection from '../components/ContactSection';
import PageMeta from '../components/PageMeta';

const Home: React.FC = () => {
  return (
    <>
      <PageMeta
        url="/"
        description="Agricampanha - Sempre ao lado do produtor. Associação dos Agricultores da Região da Campanha. Notícias, projetos e eventos do agronegócio da Campanha Gaúcha, Bagé/RS."
      />
      <Hero />
      <AboutSection />
      <DiaDeCampoCallout />
      <NewsSection />
      <QuotationsSection />
      <WeatherSection />
      {/* <InstagramSection /> */}
      <ProjectsSection />
      <ContactSection />
    </>
  );
};

export default Home;
